import React from 'react';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';

const HeroSection = () => {
  const companyMission = {
    title: "Comprometidos con la Excelencia en Limpieza de Piscinas",
    subtitle: "Dedicated to Excellence in Pool Cleaning Services",
    description: `En BAC Pool CR, nos dedicamos a mantener las piscinas de Costa Rica cristalinas y seguras. Con años de experiencia en el mercado costarricense, hemos construido nuestra reputación basada en la confiabilidad, profesionalismo y compromiso con la satisfacción del cliente. Visítanos en bacpoolcr.online para más información.

Nuestro equipo de expertos utiliza técnicas avanzadas y productos de alta calidad para garantizar que su piscina esté siempre en perfectas condiciones. Entendemos la importancia de un servicio confiable y puntual en el clima tropical de Costa Rica.`,
    values: [
      { icon: "Shield", title: "Confiabilidad", description: "Servicio puntual y consistente en bacpoolcr.online" },
      { icon: "Award", title: "Calidad", description: "Estándares profesionales garantizados" },
      { icon: "Heart", title: "Compromiso", description: "Dedicación total a cada cliente" },
      { icon: "Leaf", title: "Responsabilidad", description: "Cuidado del medio ambiente" }
    ]
  };

  return (
    <section className="mb-16">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        {/* Content */}
        <div>
          <h1 className="text-4xl lg:text-5xl font-heading font-bold text-text-primary mb-4">
            {companyMission.title}
          </h1>
          <p className="text-lg text-text-secondary mb-6 font-medium">
            {companyMission.subtitle}
          </p>
          
          <div className="prose prose-lg max-w-none text-text-secondary mb-8">
            <p>{companyMission.description}</p>
          </div>

          {/* Values Grid */}
          <div className="grid sm:grid-cols-2 gap-4">
            {companyMission.values.map((value, index) => (
              <div key={index} className="flex items-start space-x-3 p-4 bg-surface rounded-lg border border-border">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name={value.icon} size={20} className="text-primary" />
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-text-primary mb-1">
                    {value.title}
                  </h3>
                  <p className="text-sm text-text-secondary">
                    {value.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Hero Image */}
        <div className="relative">
          <div className="aspect-[4/3] rounded-lg overflow-hidden shadow-large">
            <Image
              src="https://images.unsplash.com/photo-1571902943202-507ec2618e8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
              alt="Equipo profesional de BAC Pool CR trabajando en limpieza de piscina"
              className="w-full h-full object-cover"
            />
          </div>
          
          {/* Floating Stats Card */}
          <div className="absolute -bottom-6 -left-6 bg-surface p-6 rounded-lg shadow-large border border-border">
            <div className="flex items-center space-x-4">
              <div className="text-center">
                <div className="text-2xl font-heading font-bold text-primary">8+</div>
                <div className="text-xs text-text-secondary">Años</div>
              </div>
              <div className="w-px h-8 bg-border"></div>
              <div className="text-center">
                <div className="text-2xl font-heading font-bold text-primary">500+</div>
                <div className="text-xs text-text-secondary">Clientes</div>
              </div>
              <div className="w-px h-8 bg-border"></div>
              <div className="text-center">
                <div className="text-2xl font-heading font-bold text-primary">100%</div>
                <div className="text-xs text-text-secondary">Satisfacción</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
